import httpClient from './httpClient';
import { httpRootClient } from './httpClient';
import store from '@/store';

const baseEndPoint = '/v4/registrations';
const baseEndPointPasswordRecovery = '/v4';
const socialLoginBase =
  process.env.NODE_ENV === 'production' ? process.env.VUE_APP_PUBLIC_PATH : '/';

const createUser = user => httpClient.post(`${baseEndPoint}/create-user`, user);

const socialLogin = socialLogin =>
  httpRootClient.post(
    `${socialLoginBase}login/social-network-login`,
    socialLogin,
  );

const phoneNumber = phoneNumber =>
  httpClient.put(`${baseEndPoint}/phone-number`, phoneNumber, {
    auth: store.getters['register/userToken'],
  });

const phoneVerify = code =>
  httpClient.post(`${baseEndPoint}/phone-verify`, code, {
    auth: store.getters['register/userToken'],
  });

const phoneRetry = () =>
  httpClient.get(`${baseEndPoint}/phone-retry`, {
    auth: store.getters['register/userToken'],
  });
const getCsrf = () => httpClient.get(`${baseEndPoint}/csrf`);

const documentTypes = () =>
  httpClient.get(`${baseEndPoint}/document-types`, {
    auth: store.getters['register/userToken'],
  });

const document = document =>
  httpClient.put(`${baseEndPoint}/document`, document, {
    auth: store.getters['register/userToken'],
  });

const manualDocument = files =>
  httpClient.post(`${baseEndPoint}/manual-document`, files, {
    auth: store.getters['register/userToken'],
  });

const manualDocumentSelfie = files =>
  httpClient.post(`${baseEndPoint}/manual-document-selfie`, files, {
    auth: store.getters['register/userToken'],
  });

const tocId = files =>
  httpClient.post(`${baseEndPoint}/toc-id`, files, {
    auth: store.getters['register/userToken'],
  });

const tocSelfie = files =>
  httpClient.post(`${baseEndPoint}/toc-selfie`, files, {
    auth: store.getters['register/userToken'],
  });

const documentDrive = files =>
  httpClient.post(`${baseEndPoint}/drive-document`, files, {
    auth: store.getters['register/userToken'],
  });

const getGeneralInformation = () =>
  httpClient.get(`${baseEndPoint}/general-information`, {
    auth: store.getters['register/userToken'],
  });

const getRegistrationStep = () =>
  httpClient.get(`${baseEndPoint}/status`, {
    auth: store.getters['register/userToken'],
  });

const getTocSession = () =>
  httpClient.get(`${baseEndPoint}/toc-session`, {
    auth: store.getters['register/userToken'],
  });

const generalInformation = userInformation =>
  httpClient.put(`${baseEndPoint}/general-information`, userInformation, {
    auth: store.getters['register/userToken'],
  });

const getMembership = () =>
  httpClient.get(`${baseEndPoint}/membership`, {
    auth: store.getters['register/userToken'],
  });

const membership = membershipId =>
  httpClient.post(`${baseEndPoint}/membership`, membershipId, {
    auth: store.getters['register/userToken'],
  });
const goToManual = () =>
  httpClient.put(
    `${baseEndPoint}/manual-document`,
    {},
    {
      auth: store.getters['register/userToken'],
    },
  );
const getPaymentList = () =>
  httpClient.get(`${baseEndPoint}/payment-list`, {
    auth: store.getters['register/userToken'],
  });
const getPaymentData = paymentMethodId =>
  httpClient.get(`${baseEndPoint}/payment`, {
    auth: store.getters['register/userToken'],
    params: {
      paymentMethodId,
      mobile: false,
    },
  });
const resetPassword = email =>
  httpClient.post(`${baseEndPointPasswordRecovery}/password-recovery/init`, {
    email,
  });
const resetPasswordValidateUser = token =>
  httpClient.get(`${baseEndPointPasswordRecovery}/password-recovery`, {
    params: {
      token,
    },
  });
const changePassword = changePassword =>
  httpClient.post(
    `${baseEndPointPasswordRecovery}/password-recovery?token=${changePassword.token}`,
    { password: changePassword.password },
  );
export default {
  createUser,
  phoneNumber,
  phoneVerify,
  phoneRetry,
  documentTypes,
  document,
  manualDocument,
  manualDocumentSelfie,
  tocId,
  tocSelfie,
  documentDrive,
  getGeneralInformation,
  generalInformation,
  getMembership,
  membership,
  getTocSession,
  goToManual,
  getPaymentList,
  getPaymentData,
  getRegistrationStep,
  socialLogin,
  getCsrf,
  resetPassword,
  resetPasswordValidateUser,
  changePassword,
};
